import React from "react";
import IndustryPage from "../pages/IndustryPage";
import policeData from "../translation/industries/police.json";
import PoliceHero from "../assets/images/industries/policeHero.png";
import Officer from "../assets/images/industries/officer.png";
import Fireman from "../assets/images/industries/fireman.png";
import EstateView from "../assets/images/industries/estateView.png";
import Firearms from "../assets/images/industries/firearms.png";
import CourtRoom from "../assets/images/industries/courtRoom.png";
import {
  IconUserShield,
  IconRefresh,
  IconClock,
  IconLogout2,
  IconFileSearch,
  IconCloudComputing,
  IconUpload,
  IconDatabase,
  IconCheck,
  IconListCheck,
  IconEdit,
  IconTimelineEvent,
  IconShare,
  IconTrash,
  IconReport,
  IconLock,
  IconBlockquote,
  IconRoute,
  IconAccessPoint,
  IconListDetails,
  IconMap,
} from "@tabler/icons-react";
import { Helmet } from "react-helmet";

// Icon mapping for police industry
const iconMapping = {
  IconUserShield,
  IconRefresh,
  IconClock,
  IconLogout2,
  IconFileSearch,
  IconCloudComputing,
  IconUpload,
  IconDatabase,
  IconCheck,
  IconListCheck,
  IconEdit,
  IconTimelineEvent,
  IconShare,
  IconTrash,
  IconReport,
  IconLock,
  IconBlockquote,
  IconRoute,
  IconAccessPoint,
  IconListDetails,
  IconMap,
};

// Image mapping for police industry
const imageMapping = {
  officer: Officer,
  courtRoom: CourtRoom,
  fireman: Fireman,
  estateView: EstateView,
  firearms: Firearms,
};

const Police = () => {
  return (
    <>
      <Helmet>
        <title>Police | Innaxys</title>
        <meta
          name="description"
          content="Public Safety & Criminal Justice"
        />
      </Helmet>
      <IndustryPage
        data={policeData}
        heroImage={PoliceHero}
        iconMapping={iconMapping}
        imageMapping={imageMapping}
        translationKey="police"
      />
    </>
  );
};

export default Police;
